import React from 'react';

const MenuSidebarContext = React.createContext({
  openTreeId: null,
  setOpenTreeId: () => {},
});

export default MenuSidebarContext;
